import { render, staticRenderFns } from "./APageHeader.vue?vue&type=template&id=8c1f3f04"
import script from "./APageHeader.vue?vue&type=script&lang=js"
export * from "./APageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports